import ReactOnRails from 'react-on-rails'

export const getState = () =>
  ReactOnRails.getStore('appStore').getState()

export const dispatch = action =>
  ReactOnRails.getStore('appStore').dispatch(action)



// WEBPACK FOOTER //
// app/javascript/src/helpers/store.js